export default {
	title: 'Deaktivierte Elemente',
	empty: 'Keine deaktivierten Elemente in diesem Szenario',
	no_scenario: 'Wählen Sie ein Szenario, um deaktivierte Elemente zu sehen'
};

